module.exports = __webpack_public_path__ + "static/media/Illubacker.d1da097e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Icons/Illubacker.svg
// module id = 1128
// module chunks = 0